export default __webpack_public_path__ + "static/media/Sahara.4d9a69e6.jpg";